(function () {
  /* Wade Greens - image loading priority only.

     THIS SCRIPT NEVER TOUCHES VIDEO. NOT PLAYBACK, NOT ATTRIBUTES, NOT POSTER.

     Two separate revisions of this file have broken the hero video and both
     were changes Devyn never asked for:

     1. 2026-09-26 - pruneHiddenVideos() stripped `autoplay` off any <video>
        whose computed display was `none` at DOMContentLoaded and never put it
        back. Removed in v1.48.

     2. 2026-09-27 - fixVideo()/posterFor() derived a Shopify preview-image URL
        and set it as `poster` on every <video>. The `autoplay` attribute was
        left alone, so this looked harmless. It is not: on iOS a muted,
        playsinline video that carries a `poster` paints the poster frame with
        the system play control over it until playback actually begins, which
        reads to anyone looking at the page as a video asking to be played.
        Removed in v1.52.

     Do not reintroduce either one. Do not add `poster`, `preload`,
     `controls`, `autoplay`, `muted` or `playsinline` handling here. If the
     hero ever needs a poster it is a deliberate decision made in the section
     markup, not something a performance script infers at runtime. */

  var EAGER_BUDGET = 6;
  var eagerUsed = 0;

  function fixImg(img) {
    if (img.getAttribute("data-wg-perf")) return;
    img.setAttribute("data-wg-perf", "1");
    if (eagerUsed >= EAGER_BUDGET) return;
    eagerUsed++;
    if (img.getAttribute("loading") === "lazy") img.setAttribute("loading", "eager");
    if (eagerUsed === 1) img.setAttribute("fetchpriority", "high");
  }

  function scan(node) {
    if (node.nodeType !== 1) return;
    if (node.tagName === "IMG") fixImg(node);
    if (!node.querySelectorAll) return;
    var imgs = node.querySelectorAll("img");
    for (var i = 0; i < imgs.length; i++) fixImg(imgs[i]);
  }

  try {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) scan(added[j]);
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
